<!--<particle-app-layout *ngIf="(isAuthenticated$ | async )==1"></particle-app-layout>-->
<!--<un-authorized-selector *ngIf="(isAuthenticated$ | async )==2"></un-authorized-selector>-->

<!--<app-automation-demo></app-automation-demo>>-->

<!-- <div>
    <button (click)="this.onActionReplay()">Action Replay</button>
</div> -->
<!-- The run window every user gets — the Action Monitor — and the developer's Xact editor, which shows only the runs it
     started (XAT-E-377-05). Both outside the router outlet: the run they show navigates this tab. -->
<app-action-monitor></app-action-monitor>
<app-xact-float></app-xact-float>
<!-- The in-app call (ITP-E-170-01) and the rest of the Calls feature, outside the router outlet so a call survives
     navigation. ITP2-14993: never for a magic-link-only session. -->
<app-calls-shell></app-calls-shell>
<div class="app-root-content">
    <particle-app-layout *ngIf="platformToolLayoutService.isParticleAppLayout()"></particle-app-layout>
    <app-platform-tool-app-layout
        *ngIf="platformToolLayoutService.isPlatformToolAppLayout()"></app-platform-tool-app-layout>
    <div class="session-timeout-overlay" *ngIf="isSessionTimeOutCountVisible">
        <div class="session-timeout-modal">
            <i class="fal fa-exclamation-circle session-timeout-icon"></i>
            <h2 class="session-timeout-title">Session timeout</h2>
            <p class="session-timeout-body">You will be automatically signed out shortly due to a period of inactivity.</p>
            <div class="session-timeout-countdown">{{formattedCountDown}}</div>
            <button mat-button class="session-timeout-btn" (click)="onStay()">Stay in Orbitax</button>
        </div>
    </div>

    <div *ngIf="showCookiePolicyPopup" class="cookie-policy-wrapper">
        <div class="cookie-policy-snack-bar">
            We use cookies to provide you with the best possible <br />
            experience. By using Orbitax's services, you agree that <br />
            we may store cookies on your device.
            <a href="{{cookiePolicyUrl}}" target="_blank">Cookie Policy</a>.
        </div>
        <button class="snack-bar-close-btn" (click)="onDisableCookiePolicyPopup()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

</div>
